<template>
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center vh-100">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Yuklanmoqda...</span>
        </div>
    </div>

    <div v-else-if="is404" class="container text-center d-flex flex-column justify-content-center align-items-center vh-100">
        <h1 class="display-1 fw-bold text-danger">404</h1>
        <h2 class="mb-4">Ushbu sahifa mavjud emas!</h2>
        <p class="text-muted mb-4">Siz qidirayotgan sahifa o'chirilgan yoki manzili o'zgargan bo'lishi mumkin.</p>
        <router-link to="/" class="btn btn-primary btn-lg px-4">
            Bosh sahifaga qaytish
        </router-link>
    </div>

    <template v-else>
        <Header header__white="header__white" />
        <Breadcrumb :title="dynamicPage" :subtitle="dynamicPage" />
        <AboutArea v-if="pages" :pages="pages" />
        <div v-else class="container text-center d-flex flex-column justify-content-center align-items-center" style="padding: 100px 0">
            <h1 class="display-1 fw-bold text-black">404</h1>
            <h3 class="mb-4">Ushbu sahifa mavjud emas!</h3>
            <router-link to="/" class="btn btn-primary btn-lg px-4">Bosh sahifaga qaytish</router-link>
        </div>
        <Footer footerPadding="true" />
    </template>
</template>

<script>
import Header from '@/components/Home/Header.vue';
import Breadcrumb from '@/components/common/Breadcrumb.vue';
import AboutArea from '@/components/common/AboutArea.vue';
import Footer from '@/components/Home/Footer.vue';
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '../mixins/blogMixin';

export default {
    name: 'AboutPage',
    mixins: [BlogMixin],
    components: {
        Header,
        Breadcrumb,
        AboutArea,
        Footer,
    },
    data() {
        return {
            isLoading: true, 
            is404: false     
        }
    },
     watch:{
    '$route.params.name':{
      handler(vm){
        if(vm){
          this.getPageBySlug(this.$route.params.name)
        }
      }
    }
  } ,
    async created() {
        try {
            await Promise.all([
                this.getPageBySlug(this.$route.params.name),
                this.getMenu()
            ]);
            
            if (!this.pages) {
                this.is404 = true;
            }
        } catch (error) {
            console.error("Sahifani yuklashda xatolik:", error);
            this.is404 = true;
        } finally {
            this.isLoading = false;
        }
    },
    computed: {
        ...mapGetters("allPage", ["pages"]),
        ...mapGetters('menu', ['menu']),
         dynamicPage(){
            return this.getName({ 
                nameRu: (this.menu)?.find((x) => x.id == this.pages?.menu)?.title_ru ?? 'Sahifa', 
                nameEn: (this.menu)?.find((x) => x.id == this.pages?.menu)?.title_en ?? 'Sahifa', 
                nameUz: (this.menu)?.find((x) => x.id == this.pages?.menu)?.title_uz ?? 'Sahifa' 
            })
        },
    },
    methods: {
        ...mapActions("allPage", ['getPageBySlug']),
        ...mapActions('menu', ['getMenu']),
    }
}
</script>

<style scoped>
/* Agar qo'shimcha dizayn kerak bo'lsa shu yerga yozishingiz mumkin */
.vh-100 {
    min-height: 80vh; /* Agar header/footer bilan hisoblaganda juda katta bo'lib ketsa sozlash uchun */
}
</style>


<!-- <template>
    <Header header__white="header__white" />
    <Breadcrumb :title="pageName" :subtitle="pageName" />
    <AboutArea :pages="pages" />
    <Footer footerPadding="true" />
</template>

<script>
import Header from '@/components/Home/Header.vue';
import Breadcrumb from '@/components/common/Breadcrumb.vue';
import AboutArea from '@/components/common/AboutArea.vue';
import Footer from '@/components/Home/Footer.vue';
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'AboutPage',
    components: {
        Header,
        Breadcrumb,
        AboutArea,
        Footer,
    },
    created() {
         this.getPageBySlug(this.$route.params.name)
         this.getMenu()

    },
    computed:{
            ...mapGetters("allPage", ["pages"]),
            ...mapGetters('menu', ['menu']),
            pageName() {
                return (this.menu)?.find((x)=> x.id == this.pages?.menu)?.title_uz
            }

    },
    methods:{
            ...mapActions("allPage",['getPageBySlug']),
        ...mapActions('menu', ['getMenu']),

    }
}
</script> -->
